import ISvgProps from '../../../SvgLoader/ISvgProps';

function SvgHospitality(props: ISvgProps) {
	return (
		<svg width={60} height={60} fill="none" xmlns="http://www.w3.org/2000/svg">
			<g clipPath="url(#Hospitality_svg__a)">
				<path
					d="M39.767 40.187h-.042l-18.313-.206a3.667 3.667 0 0 1-2.626-1.144 3.816 3.816 0 0 1-1.063-2.707l.13-11.639c.023-2.085 1.693-3.764 3.731-3.764h.04l18.313.205c.997.01 1.932.42 2.626 1.147a3.816 3.816 0 0 1 1.063 2.707l-.13 11.639c-.02 2.082-1.69 3.762-3.729 3.762ZM21.584 22.11c-1.296 0-2.359 1.068-2.375 2.396l-.132 11.64a2.437 2.437 0 0 0 .676 1.722 2.327 2.327 0 0 0 1.672.727l18.316.206h.026c1.296 0 2.359-1.068 2.375-2.396l.13-11.64a2.432 2.432 0 0 0-.676-1.722 2.34 2.34 0 0 0-1.672-.73l-18.314-.206c-.01.003-.018.003-.026.003Z"
					fill={props.primaryColor}
				/>
				<path
					d="m36.039 22.27-10.358-.117.019-1.78c.024-2.163 1.749-3.904 3.89-3.883l2.659.03c1.028.011 1.99.43 2.71 1.182a3.956 3.956 0 0 1 1.098 2.79l-.018 1.778Zm-8.985-1.485 7.644.084.005-.392a2.546 2.546 0 0 0-.71-1.807 2.454 2.454 0 0 0-1.755-.765l-2.658-.03c-1.388-.038-2.504 1.111-2.52 2.515l-.006.395ZM23.744 39.885l.21-18.36 1.357.017-.21 18.36-1.357-.017ZM36.184 39.236l.202-17.57 1.357.016-.202 17.57-1.357-.016Z"
					fill={props.primaryColor}
				/>
				<path
					d="M49.714 47.585H11.288v-26.6c0-10.658 8.496-19.325 18.938-19.325h.546c10.445 0 18.939 8.67 18.939 19.325l.003 26.6ZM12.644 46.2h35.713V20.985c0-9.892-7.887-17.94-17.582-17.94h-.546c-9.694 0-17.581 8.048-17.581 17.94L12.645 46.2Z"
					fill={props.secondaryColor}
				/>
				<path
					d="M54.63 54.264H6.345v-8.018H54.63v8.018ZM7.702 52.88h45.57v-5.25H7.703v5.25Z"
					fill={props.secondaryColor}
				/>
				<path
					d="M16.003 60.338c-1.924 0-3.49-1.598-3.49-3.562 0-1.963 1.566-3.561 3.49-3.561 1.924 0 3.49 1.598 3.49 3.561 0 1.964-1.566 3.562-3.49 3.562Zm0-5.736c-1.177 0-2.133.976-2.133 2.177 0 1.198.956 2.177 2.133 2.177s2.133-.976 2.133-2.177c0-1.2-.956-2.177-2.133-2.177ZM44.707 60.338c-1.924 0-3.49-1.598-3.49-3.562 0-1.963 1.566-3.561 3.49-3.561 1.924 0 3.49 1.598 3.49 3.561 0 1.964-1.563 3.562-3.49 3.562Zm0-5.736c-1.176 0-2.133.976-2.133 2.177 0 1.198.957 2.177 2.133 2.177 1.177 0 2.134-.976 2.134-2.177 0-1.2-.957-2.177-2.134-2.177Z"
					fill={props.primaryColor}
				/>
				<path
					d="M17.2 49.563h28.793v1.384H17.2v-1.385ZM47 47.16H13.808V39.2H47v7.959Zm-31.835-1.385h30.478v-5.19H15.165v5.19Z"
					fill={props.secondaryColor}
				/>
				<path
					d="M17.66 40.115h1.356v6.777h-1.357v-6.777ZM41.943 39.895H43.3v6.998h-1.357v-6.998Z"
					fill={props.secondaryColor}
				/>
			</g>
			<defs>
				<clipPath id="Hospitality_svg__a">
					<path fill="#fff" d="M0 0h60v60H0z" />
				</clipPath>
			</defs>
		</svg>
	);
}

export default SvgHospitality;
